export interface KolmeoB2CSettings {
	testAuthBaseUrl?: string;
	tenantName?: string;
	hostName?: string;
	clientId?: string;
	policySignUpSignIn?: string;
	policyForgotPassword?: string;
	redirectUrl?: string;
}

const testAuthBaseUrl = process.env.REACT_APP_TestAuth_BaseUrl;
const tenantName = process.env.REACT_APP_AzureADB2C_TenantName;
const hostName = process.env.REACT_APP_AzureADB2C_HostName;
const clientId = process.env.REACT_APP_AzureADB2C_ClientId;
const policySignUpSignIn = process.env.REACT_APP_AzureADB2C_PolicySignUpSignIn;
const policyForgotPassword = process.env.REACT_APP_AzureADB2C_PolicyForgotPassword;
const redirectUrl = process.env.REACT_APP_AzureADB2C_RedirectUrl;

export const b2cSettings: KolmeoB2CSettings = {
	testAuthBaseUrl: testAuthBaseUrl,
	tenantName: tenantName,
	hostName: hostName,
	clientId: clientId,
	policySignUpSignIn: policySignUpSignIn,
	policyForgotPassword: policyForgotPassword,
	redirectUrl: redirectUrl
};
